module.exports = __webpack_public_path__ + "img/hc_pro_ten_11.fa0f21fb.jpg";